import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=3e16e086&scoped=true"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=3e16e086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16e086",
  null
  
)

export default component.exports